import {
    httpGetPlannedAccessesDetail,
    HttpGetPlannedAccessesDetailResponse
} from '@/features/planned-accesses/http/plannedAccesses.http'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData, ResponseType} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetPlannedAccessesDetailsOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<
        UseQueryOptions<HttpGetPlannedAccessesDetailResponse, AxiosError<ErrorResponseData>>,
        'queryKey' | 'queryFn' | 'retry'
    >
}

export const useGetPlannedAccessesDetails = ({urlParams, options}: UseGetPlannedAccessesDetailsOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PLANNED_ACCESSES_DETAILS, urlParams.projectId],
        queryFn: () => httpGetPlannedAccessesDetail({urlParams, params: {responseType: ResponseType.enum.extended}}),
        retry: false,
        ...options
    })
